import { render, staticRenderFns } from "./MenuDesktop.vue?vue&type=template&id=b3c16ce8&scoped=true&"
import script from "./MenuDesktop.vue?vue&type=script&lang=js&"
export * from "./MenuDesktop.vue?vue&type=script&lang=js&"
import style0 from "./MenuDesktop.vue?vue&type=style&index=0&id=b3c16ce8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c16ce8",
  null
  
)

export default component.exports